import apiClient from "./api";
import { reduzirImagem } from "./imagemUpload";

/**
 * As chamadas de verificação de documento.
 *
 * As constantes de situação e a regra de pendência NÃO estão aqui — vivem em `verificacaoStatus`,
 * que não importa o axios. Quem só precisa comparar um status importa de lá; só quem fala com o
 * servidor importa daqui.
 */

/**
 * Verificação do usuário logado.
 *
 * Cliente (sem perfil profissional) volta com `situacao: null` — não é pendência, é ausência de
 * assunto. Quem consome precisa tratar isso como "nada a fazer", nunca como NAO_ENVIADA.
 */
export async function obterVerificacao() {
    const { data } = await apiClient.get('/verificacao/me');
    return data;
}

/**
 * Envia a foto do documento. Mesma chamada para o primeiro envio e para o reenvio depois de uma
 * recusa — do ponto de vista de quem envia é a mesma ação.
 *
 * A redução acontece aqui, e não na tela: qualquer caminho que venha a enviar documento passa a
 * subir uma imagem tratada sem precisar lembrar disso.
 */
export async function enviarDocumento(arquivo) {
    const reduzido = await reduzirImagem(arquivo);

    const corpo = new FormData();
    corpo.append('arquivo', reduzido);

    // Sem Content-Type explícito: o navegador precisa montar o boundary do multipart sozinho, e
    // fixá-lo à mão produz um corpo que o backend não consegue separar.
    const { data } = await apiClient.post('/verificacao/documento', corpo);
    return data;
}
